export const data3_1_2_default = [{
    name: '',
    name_code: "Rooms_Available",
    rooms:0,
    rooms_avaliable:0,
    rooms_sold:0,
    occ:0,
    revn:0,
    avg_rate:0,
    revpar:0,
    mpi:0,
    mpi_ranking:1,
    ari:0,
    ari_ranking:1,
    rgi:0,
    rgi_ranking:1
},{
    name: '',
    name_code: "Rooms_Available",
    rooms:0,
    rooms_avaliable:0,
    rooms_sold:0,
    occ:0,
    revn:0,
    avg_rate:0,
    revpar:0,
    mpi:0,
    mpi_ranking:1,
    ari:0,
    ari_ranking:1,
    rgi:0,
    rgi_ranking:1
},{
    name: '',
    name_code: "Rooms_Available",
    rooms:0,
    rooms_avaliable:0,
    rooms_sold:0,
    occ:0,
    revn:0,
    avg_rate:0,
    revpar:0,
    mpi:0,
    mpi_ranking:1,
    ari:0,
    ari_ranking:1,
    rgi:0,
    rgi_ranking:1
},{
    name: '',
    name_code: "Rooms_Available",
    rooms:0,
    rooms_avaliable:0,
    rooms_sold:0,
    occ:0,
    revn:0,
    avg_rate:0,
    revpar:0,
    mpi:0,
    mpi_ranking:1,
    ari:0,
    ari_ranking:1,
    rgi:0,
    rgi_ranking:1
},{
    name: '',
    name_code: "Rooms_Available",
    rooms:0,
    rooms_avaliable:0,
    rooms_sold:0,
    occ:0,
    revn:0,
    avg_rate:0,
    revpar:0,
    mpi:0,
    mpi_ranking:1,
    ari:0,
    ari_ranking:1,
    rgi:0,
    rgi_ranking:1
},{
    name: 'Total',
    name_code: "Rooms_Available",
    rooms:0,
    rooms_avaliable:0,
    rooms_sold:0,
    occ:0,
    revn:0,
    avg_rate:0,
    revpar:0,
    mpi:0,
    mpi_ranking:1,
    ari:0,
    ari_ranking:1,
    rgi:0,
    rgi_ranking:1
}]





// WEBPACK FOOTER //
// ./src/components/table/3.0/3-1/3-1-2/data.js